export const influencersParceiros = [
  {
    id: 1,
    nome: "Camila Ferreira",
    instagram: "@camilaferreira",
    seguidores: "127K",
    foto: "https://public.readdy.ai/ai/img_res/4757a9ee3355abb199b13af2df2b3ae2.jpg",
    depoimento: "O Método Bia Holmes transformou minha vida e a vida dos meus seguidores. É incrível ver tantas pessoas se reconectando com seus sonhos!",
    conversoes: 247
  },
  {
    id: 2,
    nome: "Juliana Mendes",
    instagram: "@julimendes",
    seguidores: "89K",
    foto: "https://readdy.ai/api/search-image?query=elegant-brazilian-woman-with-shoulder-length-straight-black-hair-gentle-smile-professional-portrait-photography-soft-lighting-warm-tones-sophisticated-style-age-28&width=400&height=400&seq=influencer2&orientation=squarish",
    depoimento: "Parceria perfeita! Meus seguidores amaram o método e eu acompanho cada transformação. A Bia é uma inspiração!",
    conversoes: 189
  },
  {
    id: 3,
    nome: "Patricia Oliveira",
    instagram: "@patyoliveira",
    seguidores: "156K",
    foto: "https://readdy.ai/api/search-image?query=elegant-brazilian-woman-with-curly-medium-length-brown-hair-radiant-smile-professional-portrait-photography-natural-lighting-warm-tones-sophisticated-style-age-35&width=400&height=400&seq=influencer3&orientation=squarish",
    depoimento: "Como coach, indico o método para todas as minhas clientes. Os resultados são reais e duradouros. Bia é uma referência!",
    conversoes: 312
  }
];

export const beneficiosInfluencer = [
  {
    icone: "ri-vip-crown-line",
    titulo: "Acesso Premium Gratuito",
    descricao: "Acesso completo e vitalício a todas as funcionalidades da plataforma, incluindo exercícios exclusivos de PNL."
  },
  {
    icone: "ri-link",
    titulo: "Código Exclusivo",
    descricao: "Receba um código único para compartilhar com seus seguidores e oferecer benefícios especiais."
  },
  {
    icone: "ri-bar-chart-box-line",
    titulo: "Dashboard de Métricas",
    descricao: "Acompanhe em tempo real quantas pessoas você trouxe e o impacto que está gerando."
  },
  {
    icone: "ri-star-line",
    titulo: "Destaque na Plataforma",
    descricao: "Seu perfil será destacado na comunidade como parceira oficial do Método Bia Holmes."
  },
  {
    icone: "ri-gift-line",
    titulo: "Conteúdo Exclusivo",
    descricao: "Acesso antecipado a novos exercícios, workshops e materiais exclusivos para compartilhar."
  },
  {
    icone: "ri-team-line",
    titulo: "Comunidade Exclusiva",
    descricao: "Faça parte de um grupo seleto de influencers parceiros com networking e trocas de experiências."
  }
];

export const passosInfluencer = [
  {
    numero: "01",
    titulo: "Cadastre-se",
    descricao: "Preencha o formulário de aplicação com suas informações e conte por que quer fazer parte."
  },
  {
    numero: "02",
    titulo: "Receba seu Código",
    descricao: "Após aprovação, você receberá um código exclusivo e seu link de rastreamento personalizado."
  },
  {
    numero: "03",
    titulo: "Compartilhe",
    descricao: "Divulgue o método com seus seguidores usando seu link exclusivo e código de benefícios."
  },
  {
    numero: "04",
    titulo: "Acompanhe Resultados",
    descricao: "Acesse seu dashboard e veja em tempo real o impacto que você está gerando na vida das pessoas."
  }
];